import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="page-container py-10 sm:py-12">
      <h1 className="page-heading">Home</h1>
      <p className="text-neutral-300 text-lg font-medium mb-8 max-w-2xl">
        Welcome to the Fitness App. Workouts and nutrition plans for every level.
      </p>
      <div className="grid gap-6 md:grid-cols-1 lg:max-w-2xl">
        <div className="card p-6 sm:p-8 transition-colors hover:border-neutral-500">
          <h2 className="text-xl font-bold text-white mb-3">Get Started</h2>
          <p className="text-neutral-300 leading-relaxed mb-6">
            Ready to transform your fitness journey? Start with our workout plans and nutrition guides designed for all fitness levels.
          </p>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/Workouts"
              className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
            >
              Browse Workouts
            </Link>
            <Link
              to="/Nutrition"
              className="inline-flex items-center justify-center rounded-lg border border-neutral-500 bg-transparent px-5 py-2.5 text-sm font-medium text-neutral-200 transition-colors hover:border-neutral-400 hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-neutral-500/50"
            >
              Nutrition Plans
            </Link>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <div className="card border-dashed border-neutral-600 bg-neutral-900/80 p-6 sm:p-8">
          <span className="inline-block rounded-full border border-amber-500/40 bg-amber-500/20 px-3 py-1 text-xs font-medium text-amber-400">
            Coming soon
          </span>
          <h2 className="mt-4 text-xl font-bold text-white">Progress Tracking</h2>
          <p className="mt-2 text-neutral-300 text-sm leading-relaxed">
            Track your fitness journey with progress analytics, workout history, and milestones.
          </p>
          <div className="mt-4 flex flex-wrap gap-4 text-xs text-neutral-400">
            <span className="flex items-center gap-1.5">
              <span className="h-1.5 w-1.5 rounded-full bg-blue-500" />
              Workout History
            </span>
            <span className="flex items-center gap-1.5">
              <span className="h-1.5 w-1.5 rounded-full bg-sky-500" />
              Progress Charts
            </span>
            <span className="flex items-center gap-1.5">
              <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
              Goal Setting
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
